<ion-header>
    <ion-toolbar class="shadow">
      <ion-buttons slot="start" *ngIf="previousUrl">
        <ion-back-button [defaultHref]="previousUrl" (click)="navCtrl.back()"></ion-back-button>
      </ion-buttons>
      <ion-title class="ion-text-center">
        <!-- <div style="padding-top:15px;padding-bottom:15px; display: flex; justify-content: center;"> -->
          {{'LOGIN_PAGE_TITLE' | translate }}
        <!-- </div> -->
      </ion-title>
    </ion-toolbar>
</ion-header>
<ion-content class="bg-white">
  <ion-grid>
    <!-- For later use on tablets -->
    <!-- <ion-row >
      <ion-col col-12 text-center>
            <ion-img width="110" height="110" src="/assets/imgs/default-image-32@3x.png" alt="{{'LOGIN_IMAGE_ALT' | translate}}" circle margin-top></ion-img>
      </ion-col>
    </ion-row> -->
    <ion-row>
      <ion-col size="12" class="ion-text-center" >
        <!-- <div> -->
          <ion-item>
            <ion-label position="stacked" style="margin-bottom:10px;">{{ 'LOGIN_EMAIL' | translate }}</ion-label>
            <ion-input placeholder="{{ 'LOGIN_EMAIL' | translate }}" class="input" type="email" [(ngModel)]="loginModel['email']"></ion-input>
          </ion-item>
        <!-- </div> -->

        <ion-item no-padding>
          <ion-label position="stacked" style="margin-bottom:10px;">{{ 'LOGIN_PASSWORD' | translate }}</ion-label>
          <ion-input placeholder="{{ 'LOGIN_PASSWORD' | translate }}"  class="input" type="password" [(ngModel)]="loginModel.password"></ion-input>
        </ion-item>

        <ion-item class="ion-justify-content-start">
          <ion-checkbox mode="ios" [(ngModel)]="rememberMe"></ion-checkbox>
          <ion-label style="margin-left: 15px; color: dimgray;">{{ 'LOGIN_REMEMBERME' | translate }}</ion-label>
        </ion-item>
        <div class="ion-text-right" style="margin-bottom: 20px;">
          <ion-button fill="clear" (click)="openForgotPass()">
            <div class="forgot-passw">{{ 'LOGIN_FORGOT_PASSWORD' | translate }}</div>
          </ion-button>
        </div>
        <!-- <button class="btn" ion-button block (click)="login()">
          <div style="font-weight: 700; letter-spacing: 1px;">{{ 'LOGIN_LOGIN' | translate }}</div>
        </button> -->
        <ion-button expand="block" shape="round" class="btn" (click)="login()">
          <div style="font-weight: 700; letter-spacing: 1px;">
            {{ 'LOGIN_LOGIN' | translate }}
          </div>
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" class="ion-text-center">
        <p class="ion-text-center" style="margin-top: 7px; margin-bottom: 16px; font-weight: 500;">
          {{ 'LOGIN_ARE_YOU_NEW' | translate }}
        </p>
        <ion-button
          fill="outline"
          shape="round"
          class="btn"
          style="border-width: 2px; font-weight: 700;"
          (click)="openReg()"
        >
          <!-- {{ 'LOGIN_REGISTRATION' | translate }} -->
          <div style="font-weight: 700; letter-spacing: 1px;">
            {{ 'LOGIN_REGISTRATION' | translate }}
          </div>
        </ion-button>
      </ion-col>
    </ion-row>
    <div class="login-divider">
      <div style="width: 35%;" class="lines"></div>
      <p>{{ 'SINGLE_OR' | translate | uppercase }}</p>
      <div style="width: 35%;" class="lines"></div>
    </div>
    <ion-row>
      <ion-col size="12" class="ion-text-center social-media">
        <ion-button fill="clear" size="large" (click)="onGoogleLogin()" fill="outline" shape="round" class="btn">
          <ion-icon slot="start" name="logo-google" color="primary"></ion-icon>
            {{ 'LOGIN_GOOGLE_LOGIN' | translate }}
        </ion-button>
        <ion-button fill="clear" size="large" (click)="onFacebookLogin()" fill="outline" shape="round" class="btn">
          <ion-icon slot="start" name="logo-facebook" color="primary"></ion-icon>
          {{ 'LOGIN_FACEBOOK_LOGIN' | translate }}
        </ion-button>
        <ion-button fill="clear" size="large" (click)="onAppleLogin()" fill="outline" shape="round" class="btn">
          <ion-icon slot="start" name="logo-apple" color="primary"></ion-icon>
          {{ 'LOGIN_APPLE_LOGIN' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>


    <!-- <ion-row>
      <ion-col col-12>
        <p text-center style="margin-top: 7px; margin-bottom: 16px; font-weight: 500;">{{ 'LOGIN_ARE_YOU_NEW' |
          translate }}</p>
        <button style="border-width: 2px;" class="btn" id="nobg" ion-button block outline (click)="openReg()">
          <div style="font-weight: 700;">{{ 'LOGIN_REGISTRATION' | translate }}</div>
        </button>
      </ion-col>
    </ion-row> -->
  </ion-grid>
</ion-content>